import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addLookup } from "../../redux/lookupSlice";
import { onUpdate, setSurvey } from "../../redux/surveySlice";
import { api } from "../../services/api-service";
import Input from "../layouts/Input";
import UseModal from "./UseModal";

const SurveyForm = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [fields, setFields] = useState([]);

  useEffect(() => {
    getFields();
  }, []);

  const getFields = async () => {
    const response = await api.get("get-fields?type=surveyor");
    if (response && response.ok) {
      setFields(
        response.data.data.map((field) => {
          return {
            ...field,
            handleChange: (val) => handleChange(field.name, val),
            options:
              field.type === "select" || field.type === "use"
                ? getLookup(field.name)
                : undefined,
          };
        })
      );
    }
  };

  const getLookup = async (field) => {
    if (field === "tenure" || field === "locality" || field === "currentUse") {
      const response = await api.get(`lookup?type=${field}`);
      if (response && response.ok) {
        const data = response.data.data.map((data) => {
          return { ...data, label: data.id, value: data.id };
        });
        dispatch(addLookup({ type: field, value: data }));
        return data;
      }
    }
  };

  const handleChange = (field, value) => {
    dispatch(setSurvey({ field, value }));
    dispatch(onUpdate());
  };

  return (
    <>
      {fields &&
        fields.map((field) => (
          <Input
            field={field}
            key={field.id}
            showModal={() => setModalShow(true)}
          />
        ))}
      <UseModal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};

export default SurveyForm;
